$(document).ready(function () {
    $.fn.select2.defaults.set('language', 'es');
    $('.livesearch').select2({
        placeholder: '[ Escoge ]',
        ajax: {
            url: $('.livesearch').attr('data-action'),
            dataType: 'json',
            delay: 250,
            processResults: function (data) {
                return {
                    results: $.map(data, function (item) {
                        return {
                            text: item.name,
                            id: item.id
                        }
                    })
                };
            },
            cache: true
        }
    });
});